import { ClearSearchFacets } from "@/components/search/clear-search-facets"
import { SidebarFacet } from "@/components/search/sidebar-facet"

import { useClassFacetDescriptors } from "./facet-descriptors"

export function ClassSearchFacets() {
  const descriptors = useClassFacetDescriptors()

  return (
    <>
      <ClearSearchFacets />
      {descriptors.map((descriptor) => (
        <SidebarFacet key={descriptor.id} descriptor={descriptor} />
      ))}
    </>
  )
}
